export const SET_SEARCH_CRITERIA = 'SET_SEARCH_CRITERIA';
export const SET_SERIES_TYPE_ID = 'SET_SERIES_TYPE_ID';
export const SET_SERIES_TYPE_DETAIL_ID = 'SET_SERIES_TYPE_DETAIL_ID';
export const SET_PERIODICITY_ID = 'SET_PERIODICITY_ID';
export const SET_PARENT_OBJECT_TYPE_ID = 'SET_PARENT_OBJECT_TYPE_ID';
export const SET_IS_ACTIVE = 'SET_IS_ACTIVE';
